import React, { useState } from "react";
import EAModal from "../Modal/EAModal";
import { DayPicker } from "react-day-picker";
import useLocaleByLanguage from "../../../../utils/hooks/useLocaleByLanguage";
import { addYears } from "date-fns";

interface IProps {
  title?: string;
  onClose: () => void;
  date?: Date;
  onDatePick: (date: Date) => void;
  requireConfirmation?: boolean;
  unavailableDays?: Date[];
}

const EACalendarModal: React.FC<IProps> = ({
  title = "Wybór dnia",
  onClose,
  date,
  onDatePick,
  requireConfirmation = false,
  unavailableDays,
}) => {
  const locale = useLocaleByLanguage();
  const [tempSelectedDate, setTempSelectedDate] = useState<Date | undefined>(date);

  const handleDateSelect = (selectedDate?: Date) => {
    const newDate = selectedDate || new Date();

    if (requireConfirmation) {
      setTempSelectedDate(newDate);
    } else {
      onDatePick(newDate);
    }
  };

  const handleConfirm = () => {
    if (tempSelectedDate) {
      onDatePick(tempSelectedDate);
    }
  };

  return (
    <EAModal
      isOpen
      onClose={onClose}
      title={title}
      hideAcceptButton={!requireConfirmation}
      acceptButtonLabel="Wybierz"
      onAccept={handleConfirm}
    >
      <div className="eamodal__calendar">
        <DayPicker
          mode="single"
          locale={locale}
          fromDate={new Date()}
          selected={requireConfirmation ? tempSelectedDate : date}
          onSelect={handleDateSelect}
          showOutsideDays
          toDate={addYears(new Date(), 1)}
          modifiers={unavailableDays?.length ? { unavailable: unavailableDays } : undefined}
          modifiersClassNames={
            unavailableDays?.length
              ? { selected: "my-selected", today: "my-today", unavailable: "my-unavailable" }
              : undefined
          }
        />
      </div>
    </EAModal>
  );
};

export default EACalendarModal;
